/**
 * Returns the localized description for a premium data source type
 */
export const getPremiumDataSourceTypeDescription = (sourceId, intl) => {
    switch (sourceId) {
        case 'wiley_mcp_cashmere':
            return intl.formatMessage({
                defaultMessage: 'Search business, medical, STEM, and psychology books, and medical & life sciences journals',
                id: '0a8ba362c5',
                description: 'Description for Wiley premium data source',
            });
        case 'cbinsights_mcp_cashmere':
            return intl.formatMessage({
                defaultMessage: 'Search market insights, market maps, and company activity',
                id: '3772c2c2e1',
                description: 'Description for CB Insights premium data source',
            });
        case 'pitchbook_mcp_cashmere':
            return intl.formatMessage({
                defaultMessage: 'Search firmographics for private and public companies',
                id: '68a14c1e63',
                description: 'Description for PitchBook premium data source',
            });
        case 'statista_mcp_cashmere':
            return intl.formatMessage({
                defaultMessage: 'Search aggregated statistics, market data, trends, and forecasts',
                id: '28436af04e',
                description: 'Description for Statista premium data source',
            });
        case 'midpage':
            return intl.formatMessage({
                defaultMessage: 'MidPage is an AI-powered legal research platform that helps litigators search US case law, analyze cases with AI agents, and draft legal documents like briefs and memos.',
                id: '1c322c5a0d',
                description: 'Description for Midpage premium data source',
            });
        case 'visualdx':
            return intl.formatMessage({
                defaultMessage: 'VisualDx is a clinical decision support tool that provides detailed diagnostic information, clinical images, and differential diagnoses for medical professionals.',
                id: 'c9c66b9eee',
                description: 'Description for VisualDx premium data source',
            });
        case 'nejm':
            return intl.formatMessage({
                defaultMessage: 'Search peer-reviewed clinical research, editorials, and case reports from The New England Journal of Medicine',
                id: '86b1ba582e',
                description: 'Description for NEJM premium data source',
            });
        case 'bmj':
            return intl.formatMessage({
                defaultMessage: 'Search peer-reviewed clinical research, editorials, and case reports from The BMJ (British Medical Journal)',
                id: '6b5ddd87ff',
                description: 'Description for BMJ premium data source',
            });
        default:
            return '';
    }
};
//# sourceMappingURL=getPremiumDataSourceTypeDescription.js.map